
  import { css } from 'lit';
  export const styles = css`:host{--header-text-color: var(--ig-list-header-text-color, var(--ig-secondary-700));--border-color: var(--ig-list-border-color, var(--ig-gray-200));--border-width: var(--ig-list-border-width, 0.0625rem);--ig-theme: fluent;--ig-theme-variant: light}`;
  